import { render, staticRenderFns } from "./CellFormView.vue?vue&type=template&id=ff5be010"
import script from "./CellFormView.vue?vue&type=script&lang=js"
export * from "./CellFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports